import script from "./SelectOptions.vue?vue&type=script&lang=ts&name=SelectOptions&setup=true"
export * from "./SelectOptions.vue?vue&type=script&lang=ts&name=SelectOptions&setup=true"

import "./SelectOptions.vue?vue&type=style&index=0&id=2afbe72c&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afbe72c"]])

export default __exports__